/** Replace underscores with spaces for display (keeps API values unchanged). */
export function formatLabel(value) {
  if (value == null || value === "") return "—";
  return String(value).replace(/_/g, " ");
}

export function formatMoney(value, currency = "INR") {
  if (value == null || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  const prefix = currency === "INR" ? "₹" : `${currency} `;
  return `${prefix}${num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Format API ISO timestamps in Asia/Kolkata (app timezone). */
export function formatDateTime(value) {
  if (value == null || value === "") return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}
